module.exports = __webpack_public_path__ + "static/media/logo-text-360.01781f13.svg";